import { whiteList } from "xss";

export default () => {
  const newWhiteList = JSON.parse(JSON.stringify(whiteList));
  newWhiteList["a"] = [
    "download",
    "href",
    "hreflang",
    "ping",
    "referrerpolicy",
    "rel",
    "target",
    "type",
    "title",
    "charset",
    "coords",
    "name",
    "rev",
    "shape",
  ];
  newWhiteList["area"] = [
    "alt",
    "coords",
    "download",
    "href",
    "ping",
    "referrerpolicy",
    "rel",
    "shape",
    "target",
  ];
  newWhiteList["button"] = [
    "autofocus",
    "disabled",
    "form",
    "formaction",
    "formenctype",
    "formmethod",
    "formnovalidate",
    "formtarget",
    "name",
    "popovertarget",
    "popovertargetaction",
    "type",
    "value",
  ];
  newWhiteList["caption"] = ["align"];
  newWhiteList["col"] = newWhiteList["colgroup"] = [
    "span",
    "align",
    "bgcolor",
    "char",
    "charoff",
    "valign",
    "width",
  ];
  newWhiteList["img"] = [
    "alt",
    "crossorigin",
    "decoding",
    "elementtiming",
    "fetchpriority",
    "height",
    "ismap",
    "loading",
    "longdesc",
    "referrerpolicy",
    "sizes",
    "src",
    "srcset",
    "usemap",
    "width",
    "align",
    "border",
    "hspace",
    "longdesc",
    "name",
    "vspace",
  ];
  newWhiteList["li"] = ["value"];
  newWhiteList["map"] = ["name"];
  newWhiteList["ol"] = ["reversed", "start", "type"];
  newWhiteList["style"] = [];
  newWhiteList["table"] = [
    "align",
    "bgcolor",
    "border",
    "cellpadding",
    "cellspacing",
    "frame",
    "rules",
    "summary",
    "width",
  ];
  newWhiteList["tbody"] =
    newWhiteList["tfoot"] =
    newWhiteList["thead"] =
      ["align", "bgcolor", "char", "charoff", "valign"];
  newWhiteList["td"] = newWhiteList["th"] = [
    "abbr",
    "align",
    "axis",
    "bgcolor",
    "char",
    "charoff",
    "colspan",
    "headers",
    "height",
    "nowrap",
    "rowspan",
    "scope",
    "valign",
    "width",
  ];
  newWhiteList["tr"] = ["align", "bgcolor", "char", "charoff", "valign"];
  newWhiteList["ul"] = ["compact", "type"];
  newWhiteList["video"] = [
    "autoplay",
    "controls",
    "controlslist",
    "crossorigin",
    "disablepictureinpicture",
    "disableremoteplayback",
    "height",
    "loop",
    "muted",
    "playsinline",
    "poster",
    "preload",
    "src",
    "width",
  ];

  const globalAttributes = [
    "accesskey",
    "autocapitalize",
    "autofocus",
    "class",
    "contenteditable",
    "dir",
    "exportparts",
    "hidden",
    "id",
    "itemid",
    "itemprop",
    "itemref",
    "itemscope",
    "itemtype",
    "lang",
    "part",
    "role",
    "spellcheck",
    "style",
    "tabindex",
    "title",
    "translate",
  ];

  for (const key in newWhiteList) {
    if (key === "style" || key === "script" || key === "font") {
      delete newWhiteList[key];
      continue;
    }
    newWhiteList[key] = newWhiteList[key].concat(globalAttributes);
  }
  return newWhiteList;
};
